import { defaultListener } from "../helper"
import { get } from 'lodash'

export default {
  state: {
    scheduleGroups: {}
  },
  getters: {
    getScheduleGroups(state) {
      return Object.values(state.scheduleGroups)
    },
    getScheduleGroupLabel: (state) => (id) => {
      return get(state, `scheduleGroups[${id}].label`)
    }
  },
  actions: {
    initScheduleGroups({ getters, commit }) {
      const sessionTenant = getters.getSessionTenant

      this.$firebase.firestore()
        .collection('tenants')
        .doc(sessionTenant)
        .collection('scheduleGroups')
        .onSnapshot(defaultListener.bind(this, commit, 'ADD_SCHEDULE_GROUP', 'REMOVE_SCHEDULE_GROUP')
          , e => console.log(e))
    },
    createScheduleGroup({ }, data) {
      return this.$api.post('/api/scheduleGroup', data)
    },
    updateScheduleGroup({ }, data) {
      const { id } = data
      return this.$api.post(`/api/scheduleGroup/${id}`, data)
    }
  },
  mutations: {
    ADD_SCHEDULE_GROUP(state, scheduleGroup) {
      const { id } = scheduleGroup

      if (id) {
        const newState = { ...state.scheduleGroups }
        newState[ id ] = scheduleGroup
        state.scheduleGroups = newState
      }
    },
    REMOVE_SCHEDULE_GROUP(state, id) {
      if (state.scheduleGroups[ id ]) {
        const newState = { ...state.scheduleGroups }
        delete newState[ id ]
        state.scheduleGroups = newState
      }
    }
  },
}
